import React, {Component} from "react";
import {Row, Col } from "react-bootstrap";
import {ApolloClient} from 'apollo-client';
import {Query} from "react-apollo";
import {InMemoryCache} from 'apollo-cache-inmemory';
import gql from "graphql-tag";

import HttpLinkServices from "../../services/HttpLinkServices";
import AccountService from "../../services/AccountService";
import Config from "../../config/config";
import LmsService from "../../services/LmsService";
import ErrorModal from "../Modal/ErrorModal";
import getCookie from "../Cookie/Cookie";
import Axios from "axios";
import ModuleNPSComponent from "./Components/ModuleNPSComponent";
import ModuleCertificateComponent from "./Components/ModuleCertificateComponent";
import ModuleEvaluationtComponent from "./Components/ModuleEvaluationtComponent";
import ModuleCourseComponent from "./Components/ModuleCourseComponent";
import { addToDataLayerGTM } from '../../utils/addToDataLayerGTM'

import "./styles.css";

const accountService = new AccountService();

const lms_client = new ApolloClient({
  link: HttpLinkServices.lms,
  cache: new InMemoryCache(),
});

const ACCOUNT_FIELD_VALUE = {
  RAMO_DE_ATUACAO: {
    MEU_PORTO_SEGURO: 298188
  }
}

export class CourseCarousel extends Component {

  state = {
    currentScreen: false,
    inviteStatus: "",
    courseFinished: false,
    isMPS: false,
    userHasVideo: null,
  }

  constructor() {
    super();
   this.lmsService = new LmsService();
  }

  async NPSSurveyAnswer() {
    const response = await Axios.get(`${Config.baseUrl}/api/v1/lms/resultado_pesquisa_nps`,{
      params:{
        item_id: this.props.course_id,
        item_type: "Course",
        user_token: String(getCookie("token_user")),
      }
    });
    const inviteStatus = response.data ? response.data.SurveyInviteStatus : null;
    this.setState({ inviteStatus });
  }

  // Verifica se possui o ramo de atuação MPS(Meu Porto Seguro)
  async checkIfItIsMPS(){
    const response = await accountService.getAuthenticatedUser();
    const { data } = await accountService.getUserMetas(response.data.get_authenticated_user.id);
    const userMetas = data.user.userMetas;

    const metasFiltered = userMetas.find((meta) =>
      meta.account_field_value.id === ACCOUNT_FIELD_VALUE.RAMO_DE_ATUACAO.MEU_PORTO_SEGURO
    );

    if (metasFiltered) {
      return this.setState({ isMPS: true });
    }

    this.setState({ isMPS: false });
    this.NPSSurveyAnswer();

  }

  componentDidMount() {
    this.lmsService.getUserHasVideo(this.props.course_id)
    .then(response =>  this.setState({ userHasVideo: response.data.user_has_video }));

    this.lmsService.courseHasUserItem(this.props.course_id)
    .then(response =>  this.setState({
      courseFinished: response.data.course_has_user_item ?
      response.data.course_has_user_item.id : null
    }));

    this.checkIfItIsMPS();
  }

  render() {
    return (
      <Query
        client={lms_client}
        variables={{id: this.props.course_id}}
        query={gql`
              query getCourse($id: Int!) {
                course(id:$id){
                  id,
                  title,
                  description,
                  scorm,
                  hours,
                  minutes,
                  thumbnail,
                  code,
                  video{
                    id, thumbnail
                  },
                  proof{
                    id, title
                  },
                  reactionevaluation{
                    id, title
                  }
                }
              }
            `}
      >
        {({loading, error, data}) => {
          if (loading) return <div>Carregando...</div>;
          if (error){
            // Google Tag Manager
            addToDataLayerGTM({
              'event' : 'erro',
              'etapa' : 'erro ao buscar video'
            });
            return <ErrorModal />;
          };
          window.customData.curso.modulos = data.course.proof ? 3 : 1;
          if(data.course.proof && !this.state.isMPS){
            window.customData.curso.modulos = 4;
          }
          const is_answered = this.state.inviteStatus == 647390003 ? true : false;
          const npsReference = "/curso/" + data.course.id + "/nps/" + data.course.id;
          return (
            <Row>
              <Col md={12}>
                <h2 className="title">Módulos</h2>
                <div className="vertical_carousel courseSideBar">
                  <div className={"contentSideBar"}>
                      <ModuleCourseComponent
                        course={data.course}
                        course_proof_type={this.props.course_proof_type}
                      />
                    {
                      data.course.proof && (
                        <ModuleEvaluationtComponent
                          course={data.course}
                          userHasVideo={this.state.userHasVideo}
                          videoWasWatched={this.props.videoWasWatched}
                          courseFinishState={this.props.courseFinish}
                          courseFinishedDB={this.state.courseFinished}
                          course_proof_type={this.props.course_proof_type}
                        />
                    )}

                    {
                      data.course.proof &&
                        <div>
                          {
                            !this.state.isMPS &&
                            <ModuleNPSComponent
                              courseFinishState={this.props.courseFinish}
                              courseFinishedDB={this.state.courseFinished}
                              is_answered={is_answered}
                              npsReference={npsReference}
                            />
                          }
                          <ModuleCertificateComponent
                            courseFinishState={this.props.courseFinish}
                            courseFinishedDB={this.state.courseFinished}
                            course={data.course}
                          />
                        </div>
                    }
                  </div>
                </div>
              </Col>
            </Row>
          );
        }}
      </Query>
    );
  }
}

export default CourseCarousel;



// WEBPACK FOOTER //
// ./src/components/CoursePage/CourseCarousel.jsx